const personalData = {
  name: 'Josh Macaraig',
  title: 'Product engineer for operational systems, AI workflows, and fast launches.',
  tagline: 'I turn messy business workflows into polished software people can actually run every day.',
  summary:
    'I build dashboards, internal tools, low-code backed products, and AI-assisted workflows for teams that need speed without losing product taste.',
  positioning:
    'Best fit: teams that need one builder who can clarify the workflow, shape the UX, wire the backend, and ship the first serious version.',
  availability: 'Available for selected builds',
  email: 'bajejosh@gmail.com',
  calendly: 'https://calendly.com/joshmacaraig/1-1-call-with-josh',
  github: 'https://github.com/joshmacaraig',
  linkedin: 'https://linkedin.com/in/joshmacaraig',
  twitter: 'https://twitter.com/macaraigjosh',
  memoryAthleteProfile: 'https://global-memory.org/athlete.php?id=14786',
  stats: [
    { label: 'Years shipping software', value: '6+' },
    { label: 'Selected systems', value: '7' },
    { label: 'Core stack', value: 'React + Xano' },
  ],
  focusAreas: ['Operations dashboards', 'AI workflow layers', 'Productized service systems'],
  aboutMe: `I am a multi-disciplinary builder who turns early ideas into polished, reliable tools. I work across React, Nuxt, Tailwind, WeWeb, Xano, Supabase, and automation stacks depending on what gets the product live fastest.

Most of my work sits inside operations teams: dashboards for area managers, housing platforms for agents, call grading systems, body-shop workflows, and community portals. I am usually the person bridging product requirements, UX, and the actual build.

This portfolio highlights operator-facing software, workflow systems, and launch-ready products so partners can quickly see how I approach real product problems.`,
};

export default personalData;
